<template>
  <div class="card border-0 shadow-sm">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div>
          <h6 class="mb-0">Recordatorios de Cambio de Aceite</h6>
          <p class="text-sm text-secondary mb-0">Clientes que cumplieron el plazo acordado</p>
        </div>
        <span v-if="data" class="badge" :class="data.total > 0 ? 'bg-gradient-warning' : 'bg-gradient-success'">
          {{ data.total }} pendiente{{ data.total === 1 ? '' : 's' }}
        </span>
      </div>
    </div>
    <div class="card-body">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      </div>
      <div v-else-if="data">
        <div class="table-responsive">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cliente</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Teléfono</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cada (días)</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Transcurridos</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="client in data.clients" :key="client.id">
                <td class="text-sm font-weight-bold">{{ client.name }}</td>
                <td class="text-center text-sm">{{ client.phone || '—' }}</td>
                <td class="text-center text-sm">{{ client.reminder_days }}</td>
                <td class="text-center text-sm text-danger font-weight-bold">{{ client.elapsed_days }}</td>
                <td class="text-center">
                  <button
                    class="btn btn-sm btn-success mb-0"
                    :disabled="sendingId === client.id || !client.whatsapp_phone"
                    @click="sendReminder(client)"
                  >
                    <i class="fab fa-whatsapp me-1"></i>
                    {{ sendingId === client.id ? 'Enviando...' : 'Enviar recordatorio' }}
                  </button>
                </td>
              </tr>
              <tr v-if="data.clients.length === 0">
                <td colspan="5" class="text-center text-sm text-secondary py-4">
                  No hay recordatorios pendientes. ¡Todo al día!
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/services/user.service';
import Swal from 'sweetalert2';

export default {
  name: 'OilReminderClients',
  data() {
    return {
      loading: false,
      data: null,
      sendingId: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await userService.getOilReminders();
        this.data = response.data;
      } catch (error) {
        console.error('Error loading oil reminders:', error);
      } finally {
        this.loading = false;
      }
    },
    buildWhatsAppUrl(client) {
      const firstName = String(client.name || '').trim().split(/\s+/)[0] || '';
      const message =
        `Hola ${firstName}! 🏍️ Te recordamos que ya pasó el tiempo para el ` +
        `cambio de aceite de tu moto (${client.reminder_days} días). ` +
        `Agenda tu servicio con nosotros y mantén tu moto en perfecto estado. ¡Te esperamos!`;
      return `https://wa.me/${client.whatsapp_phone}?text=${encodeURIComponent(message)}`;
    },
    async sendReminder(client) {
      // Abrir WhatsApp primero, dentro del gesto del click,
      // para que el navegador no bloqueé la ventana emergente
      window.open(this.buildWhatsAppUrl(client), '_blank');

      this.sendingId = client.id;
      try {
        await userService.markOilReminderSent(client.id);
        await Swal.fire({
          icon: 'success',
          title: 'Recordatorio enviado',
          text: `${client.name} volverá a aparecer cuando cumpla el plazo de ${client.reminder_days} días.`,
          timer: 2500,
          showConfirmButton: false,
        });
        await this.loadData();
      } catch (error) {
        console.error('Error marking reminder as sent:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo registrar el envío del recordatorio.',
        });
      } finally {
        this.sendingId = null;
      }
    },
  },
};
</script>
